module.exports = __webpack_public_path__ + "images/3d3caa06c7643eecc0c86adbca9f80cc-logo_white.png";